import logo from "../../../../images/logo2.png";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import "./index.scss";
import { logout } from "../../../../store/Auth";
import { logOutUser, selectUser } from "../../../../store/User";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import profileImg from "../../../../images/defaultPic.png";
import { useState } from "react";
import { Modal } from "antd";

interface AttClassSidebarProps {}

const AttClassSidebar: React.FunctionComponent<AttClassSidebarProps> = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const isMobile = window.innerWidth <= 768;
  const [isModalVisible, setIsModalVisible] = useState(false);

  const user = useSelector(selectUser);

  const logoutClass = () => {
    dispatch(logout(null));
    dispatch(logOutUser(null));
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  if (isMobile) {
    return (
      <div className="mobileBar">
        <div className="topbar">
          <div className="brLft">
            <button onClick={showModal}>
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 34H38"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10 24H38"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10 14H38"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <img src={logo} alt="" />
          </div>
          <div className="brRght">
            <button>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 17V16C8.44772 16 8 16.4477 8 17H9ZM15 17H16C16 16.4477 15.5523 16 15 16V17ZM9 18H15V16H9V18ZM14 17V18H16V17H14ZM10 18V17H8V18H10ZM12 20C10.8954 20 10 19.1046 10 18H8C8 20.2091 9.79086 22 12 22V20ZM14 18C14 19.1046 13.1046 20 12 20V22C14.2091 22 16 20.2091 16 18H14Z"
                  fill="white"
                />
                <path
                  d="M4.29289 14.7071L3.58579 14L3.58579 14L4.29289 14.7071ZM4.80372 14.1963L5.51082 14.9034L5.51082 14.9034L4.80372 14.1963ZM19.1963 14.1963L19.9034 13.4892L19.9034 13.4892L19.1963 14.1963ZM19.7071 14.7071L20.4142 14L20.4142 14L19.7071 14.7071ZM12 3L12 4L12 3ZM19 16H5V18H19V16ZM5 16V15.4142H3V16H5ZM5 15.4142L5.51082 14.9034L4.09661 13.4892L3.58579 14L5 15.4142ZM6 13.7224V10H4V13.7224H6ZM18 10V13.7224H20V10H18ZM18.4892 14.9034L19 15.4142L20.4142 14L19.9034 13.4892L18.4892 14.9034ZM19 15.4142V16H21V15.4142H19ZM19 15.4142L19 15.4142H21C21 14.8838 20.7893 14.3751 20.4142 14L19 15.4142ZM18 13.7224C18 14.1653 18.176 14.5901 18.4892 14.9034L19.9034 13.4892C19.9653 13.551 20 13.6349 20 13.7224H18ZM20 10C20 5.58171 16.4183 1.99999 12 2L12 4C15.3137 3.99999 18 6.68629 18 10H20ZM6 10C6 6.6863 8.68628 4.00001 12 4L12 2C7.58171 2.00001 4 5.58173 4 10H6ZM5.51082 14.9034C5.82404 14.5902 6 14.1654 6 13.7224H4C4 13.635 4.03475 13.5511 4.09661 13.4892L5.51082 14.9034ZM5 15.4142H5L3.58579 14C3.21071 14.3751 3 14.8838 3 15.4142H5ZM5 16H3C3 17.1046 3.89543 18 5 18V16ZM19 18C20.1046 18 21 17.1046 21 16H19V18Z"
                  fill="white"
                />
              </svg>
            </button>
            <img
              src={
                user?.profile?.picture !== null
                  ? user?.profile?.picture
                  : profileImg
              }
              className="prpic"
              alt=""
            />
          </div>
        </div>
        <Modal
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          closable={false}
          style={{
            margin: "0px",
            top: "0px",
            padding: "0px",
          }}
          bodyStyle={{
            height: "100vh",
            padding: "0px",
          }}
          width="70%"
        >
          <div className="navBarMb">
            <div className="flxedn">
              <button className="close" onClick={handleCancel}>
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M34.9999 34.9999L5 5"
                    stroke="#3E4047"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M35.0001 5L5 35.0001"
                    stroke="#3E4047"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div className="navs">
              <Link to={`/attendee/classroom/feed/${id}`}>
                <button
                  className={
                    location.pathname === `/attendee/classroom/feed/${id}`
                      ? "active"
                      : ""
                  }
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.18497 19.605L7.7207 18.7606C7.46683 18.5996 7.15397 18.5613 6.86874 18.6563L7.18497 19.605ZM3 21L2.05132 20.6838C1.93154 21.0431 2.02506 21.4393 2.29289 21.7071C2.56073 21.9749 2.95689 22.0685 3.31623 21.9487L3 21ZM4.39499 16.815L5.34367 17.1313C5.43875 16.846 5.40045 16.5332 5.23938 16.2793L4.39499 16.815ZM12 22C17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20V22ZM6.64923 20.4494C8.19708 21.4315 10.0337 22 12 22V20C10.4242 20 8.95764 19.5454 7.7207 18.7606L6.64923 20.4494ZM6.86874 18.6563L2.68377 20.0513L3.31623 21.9487L7.5012 20.5537L6.86874 18.6563ZM3.94868 21.3162L5.34367 17.1313L3.44631 16.4988L2.05132 20.6838L3.94868 21.3162ZM2 12C2 13.9663 2.56855 15.8029 3.5506 17.3508L5.23938 16.2793C4.45458 15.0424 4 13.5758 4 12H2ZM12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4V2ZM22 12C22 6.47715 17.5228 2 12 2V4C16.4183 4 20 7.58172 20 12H22Z"
                      fill="#C3C7CC"
                    />
                    <path
                      d="M16 12H16.002V12.002H16V12Z"
                      stroke="#C3C7CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12 12H12.002V12.002H12V12Z"
                      stroke="#C3C7CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 12H8.002V12.002H8V12Z"
                      stroke="#C3C7CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>Feeds</span>
                </button>
              </Link>
              <Link to={`/attendee/classroom/upvoted-questions/${id}`}>
                <button
                  className={
                    location.pathname ===
                    `/attendee/classroom/upvoted-questions/${id}`
                      ? "active"
                      : ""
                  }
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 20L11.5134 20.8736C11.8159 21.0421 12.1841 21.0421 12.4866 20.8736L12 20ZM12 7.16221L11.0797 7.55332C11.2365 7.9225 11.5989 8.16221 12 8.16221C12.4011 8.16221 12.7635 7.9225 12.9203 7.55332L12 7.16221ZM2 8.97234C2 12.4457 4.56031 15.4617 6.83471 17.4884C8.00373 18.5302 9.16813 19.3728 10.0381 19.9542C10.474 20.2456 10.8385 20.473 11.0958 20.6286C11.2246 20.7064 11.3267 20.7664 11.3977 20.8076C11.4332 20.8281 11.461 20.844 11.4805 20.8551C11.4902 20.8606 11.4979 20.8649 11.5034 20.868C11.5061 20.8696 11.5084 20.8708 11.51 20.8717C11.5109 20.8722 11.5116 20.8726 11.5121 20.8729C11.5124 20.8731 11.5127 20.8733 11.5129 20.8733C11.5132 20.8735 11.5134 20.8736 12 20C12.4866 19.1264 12.4868 19.1265 12.4869 19.1265C12.4869 19.1265 12.487 19.1266 12.487 19.1266C12.4871 19.1266 12.4869 19.1266 12.4867 19.1264C12.4862 19.1261 12.4851 19.1256 12.4836 19.1247C12.4804 19.1229 12.4752 19.12 12.4679 19.1158C12.4533 19.1075 12.4305 19.0945 12.4001 19.0769C12.3393 19.0417 12.2481 18.9881 12.1307 18.9172C11.8959 18.7751 11.5572 18.5639 11.1494 18.2914C10.3319 17.745 9.24627 16.9585 8.1653 15.9953C5.93969 14.012 4 11.5141 4 8.97234H2ZM12.9203 6.77109C11.7391 3.99154 9.04681 2.70458 6.60702 3.05704C5.38263 3.23392 4.21629 3.82554 3.35895 4.84728C2.49888 5.87228 2 7.26915 2 8.97234H4C4 7.66797 4.37612 6.74652 4.89105 6.13285C5.40871 5.51592 6.11737 5.14854 6.89298 5.03649C8.45319 4.8111 10.2609 5.62663 11.0797 7.55332L12.9203 6.77109ZM20 8.97234C20 11.5141 18.0603 14.012 15.8347 15.9953C14.7537 16.9585 13.6681 17.745 12.8506 18.2914C12.4428 18.5639 12.1041 18.7751 11.8693 18.9172C11.7519 18.9881 11.6607 19.0417 11.5999 19.0769C11.5695 19.0945 11.5467 19.1075 11.5321 19.1158C11.5248 19.12 11.5196 19.1229 11.5164 19.1247C11.5149 19.1256 11.5138 19.1261 11.5133 19.1264C11.5131 19.1266 11.5129 19.1266 11.513 19.1266C11.513 19.1266 11.5131 19.1265 11.5131 19.1265C11.5132 19.1265 11.5134 19.1264 12 20C12.4866 20.8736 12.4868 20.8735 12.4871 20.8733C12.4873 20.8733 12.4876 20.8731 12.4879 20.8729C12.4884 20.8726 12.4891 20.8722 12.49 20.8717C12.4916 20.8708 12.4939 20.8696 12.4966 20.868C12.5021 20.8649 12.5098 20.8606 12.5195 20.8551C12.539 20.844 12.5668 20.8281 12.6023 20.8076C12.6733 20.7664 12.7754 20.7064 12.9042 20.6286C13.1615 20.473 13.526 20.2456 13.9619 19.9542C14.8319 19.3728 15.9963 18.5302 17.1653 17.4884C19.4397 15.4617 22 12.4457 22 8.97234H20ZM12.9203 7.55332C13.7391 5.62663 15.5468 4.8111 17.107 5.03649C17.8826 5.14854 18.5913 5.51592 19.109 6.13285C19.6239 6.74652 20 7.66797 20 8.97234H22C22 7.26915 21.5011 5.87228 20.641 4.84728C19.7837 3.82554 18.6174 3.23392 17.393 3.05704C14.9532 2.70458 12.2609 3.99154 11.0797 6.77109L12.9203 7.55332Z"
                      fill="#C3C7CC"
                    />
                  </svg>
                  <span>Upvotes</span>
                </button>
              </Link>
              <Link to={`/attendee/classroom/ans-questions/${id}`}>
                <button
                  className={
                    location.pathname ===
                    `/attendee/classroom/ans-questions/${id}`
                      ? "active"
                      : location.pathname === "/attendee/edit-profile"
                      ? "active"
                      : ""
                  }
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.18497 19.605L7.7207 18.7606C7.46683 18.5996 7.15397 18.5613 6.86874 18.6563L7.18497 19.605ZM3 21L2.05132 20.6838C1.93154 21.0431 2.02506 21.4393 2.29289 21.7071C2.56073 21.9749 2.95689 22.0685 3.31623 21.9487L3 21ZM4.39499 16.815L5.34367 17.1313C5.43875 16.846 5.40045 16.5332 5.23938 16.2793L4.39499 16.815ZM12 22C17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20V22ZM6.64923 20.4494C8.19708 21.4315 10.0337 22 12 22V20C10.4242 20 8.95764 19.5454 7.7207 18.7606L6.64923 20.4494ZM6.86874 18.6563L2.68377 20.0513L3.31623 21.9487L7.5012 20.5537L6.86874 18.6563ZM3.94868 21.3162L5.34367 17.1313L3.44631 16.4988L2.05132 20.6838L3.94868 21.3162ZM2 12C2 13.9663 2.56855 15.8029 3.5506 17.3508L5.23938 16.2793C4.45458 15.0424 4 13.5758 4 12H2ZM12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4V2ZM22 12C22 6.47715 17.5228 2 12 2V4C16.4183 4 20 7.58172 20 12H22Z"
                      fill="#C3C7CC"
                    />
                    <path
                      d="M15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L15.7071 10.7071ZM11 14L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L11 14ZM9.70711 11.2929C9.31658 10.9024 8.68342 10.9024 8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L9.70711 11.2929ZM14.2929 9.29289L10.2929 13.2929L11.7071 14.7071L15.7071 10.7071L14.2929 9.29289ZM11.7071 13.2929L9.70711 11.2929L8.29289 12.7071L10.2929 14.7071L11.7071 13.2929Z"
                      fill="#C3C7CC"
                    />
                  </svg>
                  <span>Answered</span>
                </button>
              </Link>
              <button onClick={logoutClass}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.2922 24.2929C18.9017 24.6834 18.9017 25.3166 19.2922 25.7071C19.6828 26.0976 20.3159 26.0976 20.7065 25.7071L19.2922 24.2929ZM24.9993 20L25.7065 20.7071C25.894 20.5196 25.9993 20.2652 25.9993 20C25.9993 19.7348 25.894 19.4804 25.7065 19.2929L24.9993 20ZM20.7065 14.2929C20.3159 13.9024 19.6828 13.9024 19.2922 14.2929C18.9017 14.6834 18.9017 15.3166 19.2922 15.7071L20.7065 14.2929ZM6.66602 19C6.11373 19 5.66602 19.4477 5.66602 20C5.66602 20.5523 6.11373 21 6.66602 21L6.66602 19ZM20.7065 25.7071L25.7065 20.7071L24.2922 19.2929L19.2922 24.2929L20.7065 25.7071ZM25.7065 19.2929L20.7065 14.2929L19.2922 15.7071L24.2922 20.7071L25.7065 19.2929ZM6.66602 21L24.9993 21V19L6.66602 19L6.66602 21Z"
                    fill="#787F89"
                  />
                  <path
                    d="M15 11.668V8.33464C15 7.41416 15.7462 6.66797 16.6667 6.66797H31.6667C32.5871 6.66797 33.3333 7.41416 33.3333 8.33464V31.668C33.3333 32.5884 32.5871 33.3346 31.6667 33.3346H16.6667C15.7462 33.3346 15 32.5884 15 31.668V28.3346"
                    stroke="#787F89"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>Logout</span>
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }

  return (
    <div className="clsSidebar">
      <div className="logo">
        <img
          src={logo}
          alt="rankaque"
          onClick={() => navigate("/attendee/dashboard")}
        />
      </div>
      <div className="classNavs">
        <button
          className={
            location.pathname === `/attendee/classroom/feed/${id}`
              ? "active"
              : ""
          }
          onClick={() => navigate(`/attendee/classroom/feed/${id}`)}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.18497 19.605L7.7207 18.7606C7.46683 18.5996 7.15397 18.5613 6.86874 18.6563L7.18497 19.605ZM3 21L2.05132 20.6838C1.93154 21.0431 2.02506 21.4393 2.29289 21.7071C2.56073 21.9749 2.95689 22.0685 3.31623 21.9487L3 21ZM4.39499 16.815L5.34367 17.1313C5.43875 16.846 5.40045 16.5332 5.23938 16.2793L4.39499 16.815ZM12 22C17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20V22ZM6.64923 20.4494C8.19708 21.4315 10.0337 22 12 22V20C10.4242 20 8.95764 19.5454 7.7207 18.7606L6.64923 20.4494ZM6.86874 18.6563L2.68377 20.0513L3.31623 21.9487L7.5012 20.5537L6.86874 18.6563ZM3.94868 21.3162L5.34367 17.1313L3.44631 16.4988L2.05132 20.6838L3.94868 21.3162ZM2 12C2 13.9663 2.56855 15.8029 3.5506 17.3508L5.23938 16.2793C4.45458 15.0424 4 13.5758 4 12H2ZM12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4V2ZM22 12C22 6.47715 17.5228 2 12 2V4C16.4183 4 20 7.58172 20 12H22Z"
              fill="#C3C7CC"
            />
            <path
              d="M16 12H16.002V12.002H16V12Z"
              stroke="#C3C7CC"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 12H12.002V12.002H12V12Z"
              stroke="#C3C7CC"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 12H8.002V12.002H8V12Z"
              stroke="#C3C7CC"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Feeds</span>
        </button>
        <button
          onClick={() =>
            navigate(`/attendee/classroom/upvoted-questions/${id}`)
          }
          className={
            location.pathname === `/attendee/classroom/upvoted-questions/${id}`
              ? "active"
              : ""
          }
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 20L11.5134 20.8736C11.8159 21.0421 12.1841 21.0421 12.4866 20.8736L12 20ZM12 7.16221L11.0797 7.55332C11.2365 7.9225 11.5989 8.16221 12 8.16221C12.4011 8.16221 12.7635 7.9225 12.9203 7.55332L12 7.16221ZM2 8.97234C2 12.4457 4.56031 15.4617 6.83471 17.4884C8.00373 18.5302 9.16813 19.3728 10.0381 19.9542C10.474 20.2456 10.8385 20.473 11.0958 20.6286C11.2246 20.7064 11.3267 20.7664 11.3977 20.8076C11.4332 20.8281 11.461 20.844 11.4805 20.8551C11.4902 20.8606 11.4979 20.8649 11.5034 20.868C11.5061 20.8696 11.5084 20.8708 11.51 20.8717C11.5109 20.8722 11.5116 20.8726 11.5121 20.8729C11.5124 20.8731 11.5127 20.8733 11.5129 20.8733C11.5132 20.8735 11.5134 20.8736 12 20C12.4866 19.1264 12.4868 19.1265 12.4869 19.1265C12.4869 19.1265 12.487 19.1266 12.487 19.1266C12.4871 19.1266 12.4869 19.1266 12.4867 19.1264C12.4862 19.1261 12.4851 19.1256 12.4836 19.1247C12.4804 19.1229 12.4752 19.12 12.4679 19.1158C12.4533 19.1075 12.4305 19.0945 12.4001 19.0769C12.3393 19.0417 12.2481 18.9881 12.1307 18.9172C11.8959 18.7751 11.5572 18.5639 11.1494 18.2914C10.3319 17.745 9.24627 16.9585 8.1653 15.9953C5.93969 14.012 4 11.5141 4 8.97234H2ZM12.9203 6.77109C11.7391 3.99154 9.04681 2.70458 6.60702 3.05704C5.38263 3.23392 4.21629 3.82554 3.35895 4.84728C2.49888 5.87228 2 7.26915 2 8.97234H4C4 7.66797 4.37612 6.74652 4.89105 6.13285C5.40871 5.51592 6.11737 5.14854 6.89298 5.03649C8.45319 4.8111 10.2609 5.62663 11.0797 7.55332L12.9203 6.77109ZM20 8.97234C20 11.5141 18.0603 14.012 15.8347 15.9953C14.7537 16.9585 13.6681 17.745 12.8506 18.2914C12.4428 18.5639 12.1041 18.7751 11.8693 18.9172C11.7519 18.9881 11.6607 19.0417 11.5999 19.0769C11.5695 19.0945 11.5467 19.1075 11.5321 19.1158C11.5248 19.12 11.5196 19.1229 11.5164 19.1247C11.5149 19.1256 11.5138 19.1261 11.5133 19.1264C11.5131 19.1266 11.5129 19.1266 11.513 19.1266C11.513 19.1266 11.5131 19.1265 11.5131 19.1265C11.5132 19.1265 11.5134 19.1264 12 20C12.4866 20.8736 12.4868 20.8735 12.4871 20.8733C12.4873 20.8733 12.4876 20.8731 12.4879 20.8729C12.4884 20.8726 12.4891 20.8722 12.49 20.8717C12.4916 20.8708 12.4939 20.8696 12.4966 20.868C12.5021 20.8649 12.5098 20.8606 12.5195 20.8551C12.539 20.844 12.5668 20.8281 12.6023 20.8076C12.6733 20.7664 12.7754 20.7064 12.9042 20.6286C13.1615 20.473 13.526 20.2456 13.9619 19.9542C14.8319 19.3728 15.9963 18.5302 17.1653 17.4884C19.4397 15.4617 22 12.4457 22 8.97234H20ZM12.9203 7.55332C13.7391 5.62663 15.5468 4.8111 17.107 5.03649C17.8826 5.14854 18.5913 5.51592 19.109 6.13285C19.6239 6.74652 20 7.66797 20 8.97234H22C22 7.26915 21.5011 5.87228 20.641 4.84728C19.7837 3.82554 18.6174 3.23392 17.393 3.05704C14.9532 2.70458 12.2609 3.99154 11.0797 6.77109L12.9203 7.55332Z"
              fill="#C3C7CC"
            />
          </svg>
          <span>Upvotes</span>
        </button>
        <button
          onClick={() => navigate(`/attendee/classroom/ans-questions/${id}`)}
          className={
            location.pathname === `/attendee/classroom/ans-questions/${id}`
              ? "active"
              : ""
          }
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.18497 19.605L7.7207 18.7606C7.46683 18.5996 7.15397 18.5613 6.86874 18.6563L7.18497 19.605ZM3 21L2.05132 20.6838C1.93154 21.0431 2.02506 21.4393 2.29289 21.7071C2.56073 21.9749 2.95689 22.0685 3.31623 21.9487L3 21ZM4.39499 16.815L5.34367 17.1313C5.43875 16.846 5.40045 16.5332 5.23938 16.2793L4.39499 16.815ZM12 22C17.5228 22 22 17.5228 22 12H20C20 16.4183 16.4183 20 12 20V22ZM6.64923 20.4494C8.19708 21.4315 10.0337 22 12 22V20C10.4242 20 8.95764 19.5454 7.7207 18.7606L6.64923 20.4494ZM6.86874 18.6563L2.68377 20.0513L3.31623 21.9487L7.5012 20.5537L6.86874 18.6563ZM3.94868 21.3162L5.34367 17.1313L3.44631 16.4988L2.05132 20.6838L3.94868 21.3162ZM2 12C2 13.9663 2.56855 15.8029 3.5506 17.3508L5.23938 16.2793C4.45458 15.0424 4 13.5758 4 12H2ZM12 2C6.47715 2 2 6.47715 2 12H4C4 7.58172 7.58172 4 12 4V2ZM22 12C22 6.47715 17.5228 2 12 2V4C16.4183 4 20 7.58172 20 12H22Z"
              fill="#C3C7CC"
            />
            <path
              d="M15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L15.7071 10.7071ZM11 14L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L11 14ZM9.70711 11.2929C9.31658 10.9024 8.68342 10.9024 8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L9.70711 11.2929ZM14.2929 9.29289L10.2929 13.2929L11.7071 14.7071L15.7071 10.7071L14.2929 9.29289ZM11.7071 13.2929L9.70711 11.2929L8.29289 12.7071L10.2929 14.7071L11.7071 13.2929Z"
              fill="#C3C7CC"
            />
          </svg>
          <span>Answered</span>
        </button>
        <button onClick={logoutClass}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.2922 24.2929C18.9017 24.6834 18.9017 25.3166 19.2922 25.7071C19.6828 26.0976 20.3159 26.0976 20.7065 25.7071L19.2922 24.2929ZM24.9993 20L25.7065 20.7071C25.894 20.5196 25.9993 20.2652 25.9993 20C25.9993 19.7348 25.894 19.4804 25.7065 19.2929L24.9993 20ZM20.7065 14.2929C20.3159 13.9024 19.6828 13.9024 19.2922 14.2929C18.9017 14.6834 18.9017 15.3166 19.2922 15.7071L20.7065 14.2929ZM6.66602 19C6.11373 19 5.66602 19.4477 5.66602 20C5.66602 20.5523 6.11373 21 6.66602 21L6.66602 19ZM20.7065 25.7071L25.7065 20.7071L24.2922 19.2929L19.2922 24.2929L20.7065 25.7071ZM25.7065 19.2929L20.7065 14.2929L19.2922 15.7071L24.2922 20.7071L25.7065 19.2929ZM6.66602 21L24.9993 21V19L6.66602 19L6.66602 21Z"
              fill="#9DA3AB"
            />
            <path
              d="M15 11.6667V8.33341C15 7.41294 15.7462 6.66675 16.6667 6.66675H31.6667C32.5871 6.66675 33.3333 7.41294 33.3333 8.33341V31.6667C33.3333 32.5872 32.5871 33.3334 31.6667 33.3334H16.6667C15.7462 33.3334 15 32.5872 15 31.6667V28.3334"
              stroke="#9DA3AB"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default AttClassSidebar;
